module.exports = __webpack_public_path__ + "img/m-2.5c0169de.png";